import { useEffect, useRef } from "react";

import { useXdaSettingsStore } from "../context";
import { selectShowXdaValueInfo } from "../context/xdaSettingsSelectors";

export function useShowXdaInfoRef() {
  const showXdaValueInfo = useXdaSettingsStore(selectShowXdaValueInfo);

  const ref = useRef(showXdaValueInfo);
  useEffect(() => {
    ref.current = showXdaValueInfo;
  }, [showXdaValueInfo]);
  return ref;
}
